import { render } from "./DrawdownGuardBanner.vue?vue&type=template&id=175e2900&scoped=true"
import script from "./DrawdownGuardBanner.vue?vue&type=script&lang=js"
export * from "./DrawdownGuardBanner.vue?vue&type=script&lang=js"

import "./DrawdownGuardBanner.vue?vue&type=style&index=0&id=175e2900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175e2900"]])

export default __exports__